<template>
	<div id="contentScreen">
		<div class="cScreenInput">
			<Input v-model="keyWords" search enter-button placeholder="搜索视频名称" @on-search="cSearch" />
		</div>
		<div class="cScreenDep">
			<div class="cScreenSure" v-if="tagItems.length!=0">
				<Row :gutter="16">
					<Col span="2">
					<Icon type="md-checkmark-circle-outline" size="20" /><span class="cScreenTitle">已选:</span>
					</Col>
					<Col span="22">
					<div class="cScreenSureTag">
						<Tag color="primary" closable v-for="(item,index) in tagItems" @on-close="tagClose(item.num)">
							{{item.name}}
						</Tag>
					</div>
					</Col>
				</Row>
			</div>
			<div class="cScreenAllDep">
				<Row :gutter="16">
					<Col span="2">
					<Icon type="md-funnel" size="20" /><span class="cScreenTitle">筛选:</span>
					</Col>
					<Col span="22">
					<div class="cScreenDepList">
						<span class="cScreenDepitem" v-for="item in depList"><a
								@click="depSelect(item)">{{item.label}}</a></span>
					</div>
					</Col>
				</Row>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		typeCourse
	} from '../../request/api.js';
	export default {
		name: 'contentScreen',
		data() {
			return {
				keyWords: '',
				mainHigh: 0,
				tagItems: [],
				depLv: 1,
				depList: [],
				copyDepList: []
			}
		},
		methods: {
			// 清空
			empty() {
				this.tagItems = [];
				this.depLv = 1
				this.depList = this.copyDepList;
				this.keyWords = '';
				this.cSearch()
			},
			// 选择
			depSelect(data) {
				const _this = this;
				let tags = JSON.parse(JSON.stringify(_this.tagItems));
				var n = _this.depLv,
					tn = tags.length;
				let item = {
					name: data.name,
					num: n,
					id: data.typeId
				};
				if (n == tn) {
					tags.splice(tn - 1, 1)
				}
				tags.push(item);
				if (data.hasChildren) {
					_this.depLv++
					_this.depChild(data.typeId)
				}
				_this.tagItems = tags;
				_this.cSearch()
				const searchParams = new URLSearchParams(window.location.search);
				searchParams.append("b", "3");
			},
			depChild(typeId) {
				typeCourse({
					pid: typeId
				}).then(res => {
					this.depList = res.content;
				}).catch(err => {
					console.log(err)
				})

			},
			tagClose(n) {
				const _this = this;
				var needDelNum = n - 1;
				let tags = JSON.parse(JSON.stringify(_this.tagItems));
				tags.splice(needDelNum, tags.length - needDelNum);
				if (tags.length == 0) {
					_this.depList = _this.copyDepList;
				} else {
					_this.depChild(tags[tags.length - 1].id);
				}
				_this.tagItems = tags;
				_this.depLv = tags.length + 1;
				_this.cSearch()
			},
			cSearch() {
				// let s = {
				// 	keyWords: this.keyWords,
				// 	dep: this.tagItems
				// }
				this.$router.push({
					query: {
						search: this.keyWords,
						type: JSON.stringify(this.tagItems)
					}
				})
				// console.log(s)
				// this.$emit('csData', s);
			},
			urlSearch(val){
				let query = val.query;
				let types = []
				if (query.type) {
					types = JSON.parse(query.type)
				}
				this.keyWords = query.search
				this.tagItems = types
				let s = {
					keyWords: query.search,
					dep: types
				}
				this.$emit('csData', s);
			}
		},
		mounted() {
			typeCourse().then(res => {
				this.depList = res.content;
				this.copyDepList = res.content
			}).catch(err => {
				console.log(err)
			})
			this.urlSearch(this.$route)
		},
		watch: {
			$route: {
				handler: function(val, oldval) {
					var _this = this;
					_this.urlSearch(val)
				},
				// 深度观察监听
				deep: true
			}
		}

	}
</script>

<style>
	.cScreenInput {
		margin-bottom: 20px;
	}

	.cScreenDep {
		font-size: 16px;
		line-height: 32px;
	}

	.cScreenAllDep {
		margin-top: 10px;
	}

	.cScreenTitle {
		font-weight: bold;
		margin-left: 10px;
	}

	.cScreenDepitem {
		margin-right: 10px;
	}

	.cScreenDepitem a {
		color: #115467;
	}

	.cScreenDepitem a:hover {
		font-weight: bold;
		border-bottom: 2px solid #115467;
	}
</style>